<app-match-header *ngIf="match" [matchInfo]="match"></app-match-header>
<div class="container-padding">
  <ng-container *ngIf="isValid == false">
    <div class="centered fail-mobile">
      <img
        style="width: 15rem"
        src="assets/images/tickets/failure.svg"
        alt=""
      />
      <div>
        <h2 class="title">{{ "BookingFailed" | translate }}</h2>
      </div>
      <button type="button" class="btn btn-primary btn-fail" [routerLink]="'/'">
        {{ "TryAgain" | translate }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="isValid">
    <div class="centered">
      <img
        style="width: 15rem"
        src="assets/images/tickets/success.svg"
        alt=""
      />
      <div>
        <div class="title">{{ "BookingSuccess" | translate }}</div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="tickets && orders?.length && isValid">
    <div class="tickets-container">
      <div *ngIf="match" class="match-details">
        <div class="match-details__team">
          <img [src]="match?.teamHome?.logo" />

          <div class="match-details__team-name">
            {{ helpers.getElementTranslatedName(match?.teamHome) }}
          </div>
        </div>

        <div class="match-details__details">
          <div class="match-details__details-time">
            {{
              match?.date
                | customDatePipe : ["mediumDate", translate.currentLang]
            }}
            ,
            {{ match?.time | timePipe : [translate.currentLang] }}
          </div>
          <div class="match-details__details-stadium">
            {{ helpers.getElementTranslatedName(match?.stadium) }}
          </div>
        </div>
        <div class="match-details__team">
          <img [src]="match?.teamAway?.logo" />

          <div class="match-details__team-name">
            {{ helpers.getElementTranslatedName(match?.teamAway) }}
          </div>
        </div>
      </div>
      <hr class="dashed" />

      <div class="ticket-details">
        <div>
          <p class="info-title">{{ "your name" | translate }}</p>
          <p class="info-value">
            {{ tickets.invoice.firstName + " " + tickets.invoice.lastName }}
          </p>
          <p style="unicode-bidi: plaintext" class="info-title">
            {{ tickets?.invoice?.mobile }}
          </p>
        </div>
        <div>
          <p class="info-title">{{ "Sport.Total" | translate }}</p>
          <div class="info-value d-flex gap-1">
            <span
              *ngIf="tickets.invoice.ticket.price > 0"
              [ngClass]="
                !tickets.invoice.ticket.needToPay &&
                tickets.invoice.ticket.price > 0
                  ? 'line'
                  : ''
              "
              [innerHTML]="
                !tickets.invoice.ticket.needToPay &&
                tickets.invoice.ticket.price > 0
                  ? tickets.invoice.total
                  : (tickets.invoice.total
                    | customCurrency : 'SAR' : 'symbol' : '#28293d' : 18)
              "
            >
            </span>

            <span *ngIf="tickets.invoice.ticket.price === 0">
              {{ "free" | translate }}
            </span>
          </div>
          <p class="info-title" *ngIf="tickets.invoice.ticket.price !== 0">
            {{ tickets.invoice.ticket.price }}
            {{ "Sport.PerTicket" | translate }} + {{ tickets.invoice.vat }}
            {{ "Sport.Tax" | translate }}
          </p>
        </div>

        <div>
          <p class="info-title">{{ "Details" | translate }}</p>
          <p class="info-value">
            {{ tickets.invoice.ticket.gate }}
          </p>
          <p class="info-title">
            {{ helpers.getElementTranslatedName(team) }}
          </p>
        </div>
      </div>
      <hr class="dashed" />
      <div class="invoice-actions">
        <div class="invoice-actions__title">
          {{
            "tickets-bought-quantity" | translate : { value: orders?.length }
          }}
        </div>
        <ng-container *ngIf="tickets.invoice.ticket.needToPay">
          <button
            *ngIf="!allTicketsTransferred(orders)"
            class="invoice-actions__btn"
            (click)="transferInvoice()"
          >
            <img src="/assets/images/icons/green-share.svg" />
            <span class="mx-1" style="color: #43c0b5">
              {{ "Sport.TransferAllTickets" | translate }}
            </span>
          </button>

          <button
            class="invoice-actions__btn"
            *ngIf="
              allTicketsUnderTransfer(orders) && allTicketsTransferred(orders)
            "
            (click)="cancelInvoice()"
          >
            <img src="assets/images/events/close.png" />
            <span class="mx-1" style="color: #727385">
              {{ "Sport.CancelTransferAll" | translate }}
            </span>
          </button>
        </ng-container>
      </div>

      <div class="invoice-orders">
        <app-sport-order-item
          *ngFor="let order of orders"
          [order]="order"
          [hours]="hours"
          [ticket]="tickets.invoice.ticket"
          (transferTicketEvent)="transferTicket($event)"
          (transferDisabledTicketEvent)="transferDisabledTicket($event)"
          (cancelTicketEvent)="cancelTicket($event)"
        ></app-sport-order-item>
      </div>
    </div>
  </ng-container>
</div>

<div class="book-footer">
  <button routerLink="/" class="btn pay-now-btn back-mobile">
    <i
      *ngIf="translate.currentLang == 'ar'"
      class="fas fa-arrow-right mx-2"
    ></i>
    <i *ngIf="translate.currentLang == 'en'" class="fas fa-arrow-left mx-2"></i>

    {{ "Go back" | translate }}
  </button>
</div>
